import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import Select from '@mui/material/Select';
import './index.scss';

export default function CommonIconButton(props) {
  const {
    title,
    value,
    options,
    selectChange,
    isMobile = false,
    selectStyle={}
  } = props;

  const { t } = useTranslation();

  return (
    <div className={`${isMobile ? 'mobile' : 'web'}-custom-select`} style={selectStyle}>
      <div className="title">{title}</div>
      <Select
        value={value}
        onChange={(event) => {
          selectChange(event.target.value);
        }}
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{
          borderRadius: '0rem',
          fontFamily: 'var(--text-font-family)',
          border: '0.125rem solid #004899',
          color: '#004899',
          fontSize: isMobile ? '1rem' : '1.375rem',
          fontWeight: '500',
          '&.Mui-selected': {
            border: '0rem solid #ffffff'
          },
          '.MuiSelect-select': {
            width: isMobile ? '11rem' : '12.5rem',
            padding: '0.5rem 0.75rem 0.5rem 1rem',
            paddingRight: '2.5rem !important'
          }
        }}
      >
        {
          options.length > 0 && options.map((item, index) => {
            return (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{
                  color: '#004899',
                  fontSize:  isMobile ? '1rem' : '1.375rem',
                  fontWeight: '500'
                }}
              >
                {t(`news.${item.label}`)}
              </MenuItem>
            );
          })
        }
      </Select>
    </div>
  );
}